// Helpers

import { InterpolationParams } from "./model";

const templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

export namespace TranslateHelpers {
  export function interpolate(value: any, params: InterpolationParams) {
    return value == null || typeof value !== "string"
      ? value
      : value.replace(templateMatcher, (substring: string, key: string) => getValue(params, key) ?? substring);
  }

  export function getValue(target: Object | undefined, key: string | string[]) {
    const keys = typeof key === "string" ? key.split(".") : Array.isArray(key) ? key : [key];

    const { result } = keys.reduce(
      ({ currentKey, result }, keySegment, i) => {
        const isLast = i === keys.length - 1;
        currentKey += keySegment;

        if (result?.[currentKey] != null && (typeof result[currentKey] === "object" || isLast)) {
          return { currentKey: "", result: result[currentKey] };
        } else if (isLast) {
          return { currentKey, result: undefined };
        } else {
          return { currentKey: currentKey + ".", result };
        }
      },
      { currentKey: "", result: target }
    );

    return result == null ? undefined : result;
  }
}
